module.exports = __webpack_public_path__ + "media/images/close-tag-icon-hover-d86fb67184ff1f04dd83d1a94463e8b9.png";